var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 74
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27-29H93V91H-27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.873 35C11.193 35 2 42.866 2 57.177v1.895h51.84v-1.895C53.745 42.866 44.552 35 27.873 35zm.227-3.907c7.108 0 13-6.734 13-14.964 0-8.043-5.612-14.029-13-14.029s-13 6.08-13 14.029c0 8.324 5.892 14.964 13 14.964z",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 3,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    transform: "translate(33 31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#042B75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001A5D",
    strokeWidth: 3,
    d: "M18.5 8C12.701 8 8 12.701 8 18.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeWidth: 4,
    d: "M32.5 32.5l7.018 7.018"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NiIgaGVpZ2h0PSI3NCIgdmlld0JveD0iMCAwIDc2IDc0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0yNy0yOUg5M1Y5MUgtMjd6Ii8+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMyIgb3BhY2l0eT0iLjciPgogICAgICAgICAgICA8cGF0aCBkPSJNMjcuODczIDM1QzExLjE5MyAzNSAyIDQyLjg2NiAyIDU3LjE3N3YxLjg5NWg1MS44NHYtMS44OTVDNTMuNzQ1IDQyLjg2NiA0NC41NTIgMzUgMjcuODczIDM1ek0yOC4xIDMxLjA5M2M3LjEwOCAwIDEzLTYuNzM0IDEzLTE0Ljk2NCAwLTguMDQzLTUuNjEyLTE0LjAyOS0xMy0xNC4wMjlzLTEzIDYuMDgtMTMgMTQuMDI5YzAgOC4zMjQgNS44OTIgMTQuOTY0IDEzIDE0Ljk2NHoiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgc3Ryb2tlPSIjRkZGIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMyAzMSkiPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE4IiByPSIxOCIgZmlsbD0iIzA0MkI3NSIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMwMDFBNUQiIHN0cm9rZS13aWR0aD0iMyIgZD0iTTE4LjUgOEMxMi43MDEgOCA4IDEyLjcwMSA4IDE4LjUiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSI0IiBkPSJNMzIuNSAzMi41bDcuMDE4IDcuMDE4Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFindUser as ReactComponent };